import type { Saga } from 'redux-saga'
import userSaga from './sagas/user'
import workspaceSaga from './sagas/workspace'

const initialSagas: Record<string, Saga> = {
  user: userSaga,
  workspace: workspaceSaga
}
export default initialSagas
